import { render } from "./salonPriceList.vue?vue&type=template&id=0fab9ce6&scoped=true"
import script from "./salonPriceList.vue?vue&type=script&lang=js"
export * from "./salonPriceList.vue?vue&type=script&lang=js"

import "./salonPriceList.vue?vue&type=style&index=0&id=0fab9ce6&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fab9ce6"]])

export default __exports__